// extracted by mini-css-extract-plugin
export var searchHeader = "_3v-0";
export var searchHeaderDark = "_3v-1";